import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./User_Management_Sidebar.css";
import { FixIDS } from "../../../../utils/fixIDS";
import { useSelector } from "react-redux";

const User_Management_Sidebar = () => {

   const nested_menu = {
    location: [
      {
        label: "Country",
        Link: "country",
        permission_ids: [FixIDS.Country.List],
      },
      {
        label: "State",
        Link: "state",
        permission_ids: [FixIDS.State.List],
      },
      {
        label: "City",
        Link: "city",
        permission_ids: [FixIDS.City.List],
      },
    ],
  };

  const userManagementNav = [
    { title: "Roles", link: "roles", permission_ids: [FixIDS.Roles.List] },
    { title: "User", link: "user", permission_ids: [FixIDS.User.List] },
    {
      title: "Method Of Testing",
      link: "methodoftesting",
      permission_ids: [FixIDS.method_of_testing.List],
    },
    {
      title: "Customer Type",
      link: "customertype",
      permission_ids: [FixIDS.customer_type.List],
    },
    {
      title: "Preferred Communication Mode",
      link: "prefferedcommunicationmode",
      permission_ids: [FixIDS.preffered_communication_mode.List],
    },
    {
      title: "Parameters",
      link: "parameters",
      permission_ids: [FixIDS.parameters.List],
    },
    {
      title: "Material Tested",
      link: "material_tested",
      permission_ids: [FixIDS.material_tested.List],
    },
    {
      title: "Test Method",
      link: "test_method",
      permission_ids: [FixIDS.test_method.List],
    },
    {
      title: "Component",
      link: "component",
      permission_ids: [FixIDS.component.List],
    },
    {
      title: "Test Type",
      link: "test_type",
      permission_ids: [FixIDS.test_type.List],
    },
    {
      title: "Relevant Training",
      link: "relevant_training",
      permission_ids: [FixIDS.relevant_training.List],
    },
    {
      title: "Designation",
      link: "designation",
      permission_ids: [FixIDS.designation.List],
    },
    {
      title: "Qualification",
      link: "qualification",
      permission_ids: [FixIDS.qualification.List],
    },
    {
      title: "Specialization",
      link: "specialization",
      permission_ids: [FixIDS.specialization.List],
    },
    {
      title: "Room Type",
      link: "roomtype",
      permission_ids: [FixIDS.room_type.List],
    },
    {
      title: "Service Used",
      link: "serviceused",
      permission_ids: [FixIDS.service_used.List],
    },
    {
      title: "Verification Type",
      link: "type_of_verification",
      permission_ids: [FixIDS.type_of_verification.List],
    },
    {
      title: "Tested By",
      link: "tested_by",
      permission_ids: [FixIDS.tested_by.List],
    },
    {
      title: "Nature Of Complaint",
      link: "nature_of_complaint",
      permission_ids: [FixIDS.nature_of_complaint.List],
    },
    {
      title: "Department",
      link: "department",
      permission_ids: [FixIDS.department.List],
    },

     {
      title: "Payment Method",
      link: "payment-method",
      permission_ids: [FixIDS.payment_method.List],
    },
    {
      title: "Training Type",
      link: "training-type",
      permission_ids: [FixIDS.type_of_training.List],
    },
    {
      title: "Training Of Field",
      link: "training-field",
      permission_ids: [FixIDS.training_field.List],
    },
     {
      title: "Instrument Maintenance Status",
      link: "maintenance-status",
      permission_ids: [FixIDS.instrument_name.List],
    },
    
  ];

 
  const [openMenu, setOpenMenu] = useState("");

  const userPermissions = useSelector((state) => state.auth.permissions);

  const normalizePermissions = (permission_ids) => {
    if (!permission_ids) return [];
    return Array.isArray(permission_ids) ? permission_ids : [permission_ids];
  };

  const hasPermission = (nav) => {
    const required = normalizePermissions(nav?.permission_ids);
    if (required.length === 0) return true; // no permission → show
    return required.some((id) => userPermissions?.includes(id));
  };

  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? "" : menu);
  };

  const [openManagement, setOpenManagement] = useState(true);
  const [activeSub, setActiveSub] = useState("");

  const renderSubMenu = (menuKey) => (
    <div className="submenu">
      {nested_menu[menuKey]
        .filter((item) => {
          // if item has children → check children permissions
          if (item.children) {
            return item.children.some((child) => hasPermission(child));
          }
          // normal item
          return hasPermission(item);
        })
        .map((item, index) => {
          if (item.children) {
            return (
              <div className="submenu_group" key={index}>
                <button
                  className={`submenu_item has_child menu_header ${
                    openManagement ? "active" : ""
                  }`}
                  onClick={() => setOpenManagement(!openManagement)}
                >
                  {item.label}
                  <span className="arrow">
                    <FontAwesomeIcon
                      icon={openManagement ? faAngleDown : faAngleRight}
                    />
                  </span>
                </button>

                {openManagement && (
                  <div className="nested_submenu">
                    {item.children
                      .filter((child) => hasPermission(child))
                      .map((child, i) => (
                        <Link to={child.Link} key={i}>
                          <button
                            className={`submenu_item nested ${
                              activeSub === child.Link ? "active" : ""
                            }`}
                            onClick={() => setActiveSub(child.Link)}
                          >
                            {child.label}
                          </button>
                        </Link>
                      ))}
                  </div>
                )}
              </div>
            );
          }

          return (
            <Link to={item.Link} key={index}>
              <button
                className={`submenu_item ${
                  activeSub === item.Link ? "active" : ""
                }`}
                onClick={() => setActiveSub(item.Link)}
              >
                {item.label}
              </button>
            </Link>
          );
        })}
    </div>
  );

  return (
    <section className="Report_Analysis_Sidebar User_Management_Sidebar common_sidemenu p-2">

      {Object.keys(nested_menu).map((menu) => (
        <div className="menu_section" key={menu}>
          <button
            className={`menu_header ${openMenu === menu ? "active" : ""}`}
            onClick={() => toggleMenu(menu)}
          >
            {menu.charAt(0).toUpperCase() + menu.slice(1)}
            <span className="arrow">
              <FontAwesomeIcon
                icon={openMenu === menu ? faAngleDown : faAngleRight}
              />
            </span>
          </button>

          {openMenu === menu && renderSubMenu(menu)}
        </div>
      ))}
      <div className="menu_section">
        {userManagementNav
          .filter((item) => {
            // if parent has children → check child permissions
            if (item.children) {
              return item.children.some((child) => hasPermission(child));
            }
            return hasPermission(item);
          })
          .map((item, index) => {
            const currentSegment = location.pathname.split("/").pop();
            const isActive = currentSegment === item.link;
            const isOpen = openMenu === item.title;

            /* ================= WITH SUBMENU ================= */
            if (item.children) {
              return (
                <div className="submenu_group" key={index}>
                  <button
                    className={`menu_header has_child ${
                      isOpen ? "active" : ""
                    }`}
                    onClick={() => setOpenMenu(isOpen ? "" : item.title)}
                  >
                    {item.title}
                    <span className="arrow">
                      <FontAwesomeIcon
                        icon={isOpen ? faAngleDown : faAngleRight}
                      />
                    </span>
                  </button>

                  {isOpen && (
                    <div className="nested_submenu">
                      {item.children
                        .filter((child) => hasPermission(child))
                        .map((child, i) => {
                          const isChildActive = currentSegment === child.link;

                          return (
                            <button
                              key={i}
                              className={`submenu_item nested ${
                                isChildActive ? "active" : ""
                              }`}
                              onClick={() => navigate(child.link)}
                            >
                              {child.title}
                            </button>
                          );
                        })}
                    </div>
                  )}
                </div>
              );
            }

            /* ================= NORMAL MENU ================= */
            return (
              <button
                key={index}
                className={`menu_header ${isActive ? "active" : ""}`}
                onClick={() => navigate(item.link)}
              >
                {item.title}
                <span className="arrow">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </button>
            );
          })}
      </div>

      
    </section>
  );
};

export default User_Management_Sidebar;
